import React from 'react';
import SelectFilter from './SelectFilter';

const FrameworkFilter = ({ selectedFramework, setSelectedFramework }) => {
  const frameworks = ['All Frameworks', 'Playwright', 'WDIO'];

  return (
    <SelectFilter 
      options={frameworks} 
      selectedValue={selectedFramework} 
      setSelectedValue={setSelectedFramework} 
    />
  );
};

export default FrameworkFilter;